<template>
  <div class="recharge_left capital_first">
    <div class="perfect_content">
      <div class="content_title">安全设置</div>
      <div class="content_table">
        <table border="0" cellspacing="0" cellpadding="0">
          <!--已有昵称状态-->
          <tr>
            <td>
              <img src="../assets/img/perfect_name.png">
              <span>昵称</span>
            </td>
            <td>
              <div>{{nickName}}</div>
              <div class="modifyName demo_click1" @click="nickFadeIn">{{nickStatus}}</div>
            </td>
          </tr>
          <!--实名已认证-->
          <tr>
            <td>
              <img src="../assets/img/perfect_activate.png">
              <span>实名认证</span>
            </td>
            <td>
              <div>{{real}}</div>
              <div @click="realFadeIn">{{realStatus}}</div>
            </td>
          </tr>
          <!--银行卡已绑定-->
          <tr>
            <td>
              <img src="../assets/img/perfect_bank.png">
              <span>银行卡绑定</span>
            </td>
            <td>
              <div>
                <span>{{bank}}{{bankName}}&nbsp;{{bankValue}}</span>
                <span>{{backAccess}}</span>
              </div>
              <div class="modifyBank demo_click3" @click="bankFadeIn">{{bankStatus}}</div>
            </td>
          </tr>
          <!--手机绑定-->
          <tr>
            <td>
              <img src="../assets/img/perfect_phone.png">
              <span>手机绑定</span>
            </td>
            <td>
              <div>{{phone}}</div>
              <div class="modifyPhone demo_click5" @click="phoneFadeIn">{{phoneStatus}}</div>
            </td>
          </tr>
          <!--登录密码已设置-->
          <tr>
            <td>
              <img src="../assets/img/perfect_suo.png">
              <span>登录密码</span>
            </td>
            <td>
              <div>已设置</div>
              <div class="modifyPassword demo6_click" @click="loginFadeIn">修改</div>
            </td>
          </tr>
          <!--提款密码 已设置-->
          <tr>
            <td>
              <img src="../assets/img/perfect_suo2.png">
              <span>提款密码</span>
            </td>
            <td>
              <div>{{pay}}</div>
              <div class="modifyGetPass demo7_click" @click="payFadeIn">{{payPassStatus}}</div>
            </td>
          </tr>
          <!--绑定邮箱-->
          <tr>
            <td>
              <img src="../assets/img/account11_14.png" style="width: 20px;height: 20px;">
              <span>绑定邮箱</span>
            </td>
            <td style="border:none;">
              <div>{{email}}</div>
              <div class="modifyGetPass demo10_click" @click="emailFadeIn">{{emailStatus}}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 实名认证 弹窗 -->
    <div class="modify-real modifybox">
      <div class="modify2 demo2">
        <div class="modify_title">
          <div>实名认证</div>
          <div @click="realFadeOut">x</div>
        </div>
        <el-input
          placeholder="请输入真实姓名"
          v-model="inputReal"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <el-input
          placeholder="请输入身份证号"
          v-model="inputIdcard"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setReal">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 银行卡绑定 修改 弹窗-->
    <div class="modify-bank modifybox">
      <div class="modify5 demo3">
        <div class="modify_title">
          <div>绑定银行卡</div>
          <div @click="bankFadeOut">x</div>
        </div>
        <select class="select-class" v-model="bankId">
          <option v-for="(item,index) in bankList" :key="index" :value="item.id">{{item.bank}}</option>
        </select>
        <el-input
          placeholder="请输入银行卡号"
          v-model="inputBankCode"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <el-input
          placeholder="请输入开户人姓名"
          v-model="inputBankName"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <el-input
          placeholder="请输入开户行支行"
          v-model="inputBankAccess"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setBank">确认</el-button>
        </div>
      </div>
    </div>
    <!--弹窗 修改昵称-->
    <div class="modify-nick modifybox">
      <div class="modify1 demo1">
        <div class="modify_title">
          <div>修改昵称</div>
          <div @click="nickFadeOut">x</div>
        </div>
        <el-input
          placeholder="请输入昵称"
          v-model="inputNickName"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setNick">确认</el-button>
        </div>
      </div>
    </div>
    <!--弹窗 修改手机号码-->
    <div class="modify-phone modifybox">
      <div class="modify3 demo1" style="height:300px;">
        <div class="modify_title">
          <div>绑定手机号码</div>
          <div @click="phoneFadeOut">x</div>
        </div>
        <el-input
          type="tel"
          maxlength="11"
          placeholder="请输入手机号码"
          v-model="inputPhone"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
      
        <div class="modify-codebox">
          <el-input
            type="text"
            class="modify-code"
            placeholder="请输入验证码"
            v-model="inputPhoneCode"
            clearable
          ></el-input>
          <el-button
            type="info"
            class="get-code"
            @click="getCode"
            :disabled="disabled"
          >{{getCodeText}}</el-button>
        </div>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setPhone">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 修改登录密码 弹窗 -->
    <div class="modify-login modifybox">
      <div class="modify4 demo2">
        <div class="modify_title">
          <div>登录密码</div>
          <div @click="loginFadeOut">x</div>
        </div>
        <el-input
          type="tel"
          v-model="inputLoginPhone"
          clearable
          disabled
          class="modify1_content getPass"
          style="display:none;"
        ></el-input>
        <div class="modify-codebox">
          <el-input  class="repic-code"  v-model="loginRePicCode" placeholder="请输入图形验证码"></el-input>
          <img :src="captcha"  height="50" width="150" @click="this.getCaptcha">

        </div>
       
        <div class="modify-codebox">
          <el-input
            type="text"
            class="modify-code"
            placeholder="请输入验证码"
            v-model="inputLoginCode"
            clearable
          ></el-input>
          <el-button
            type="info"
            class="get-code"
            @click="getLoginCode"
            :disabled="disabled2"
          >{{getLoginCodeText}}</el-button>
        </div>
        <el-input
          type="password"
          placeholder="请输入新密码"
          v-model="inputLoginPass"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <el-input
          type="password"
          placeholder="请输入确认密码"
          v-model="inputLoginConf"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setLoginPass">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 修改支付密码 弹窗 -->
    <div class="modify-pay modifybox">
      <div class="modify4 demo2">
        <div class="modify_title">
          <div>提款密码</div>
          <div @click="payFadeOut">x</div>
        </div>
        <el-input
          type="tel"
          v-model="inputLoginPhone"
          clearable
          disabled
          class="modify1_content getPass"
          style="display:none;"
        ></el-input>
        <div class="modify-codebox">
          <el-input  class="repic-code"  v-model="payRePicCode" placeholder="请输入图形验证码"></el-input>
          <img :src="captcha"  height="50" width="150" @click="this.getCaptcha">

        </div>
        <div class="modify-codebox">
          <el-input
            type="text"
            class="modify-code"
            placeholder="请输入验证码"
            v-model="inputPayCode"
            clearable
          ></el-input>
          <el-button
            type="info"
            class="get-code"
            @click="getPayCode"
            :disabled="disabled3"
          >{{getPayCodeText}}</el-button>
        </div>
        <el-input
          type="password"
          placeholder="请输入密码"
          v-model="inputPayPass"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <el-input
          type="password"
          placeholder="请输入确认密码"
          v-model="inputPayConf"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setPayPass">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 修改支付密码 弹窗 -->
    <div class="modify-email modifybox">
      <div class="modify4 demo2">
        <div class="modify_title">
          <div>绑定邮箱</div>
          <div @click="emailFadeOut">x</div>
        </div>
        <el-input
          type="tel"
          v-model="inputLoginPhone"
          clearable
          disabled
          class="modify1_content getPass"
          style="display:none;"
        ></el-input>
        <div class="modify-codebox">
          <el-input
            type="text"
            class="modify-code"
            placeholder="请输入验证码"
            v-model="inputEmailCode"
            clearable
          ></el-input>
          <el-button
            type="info"
            class="get-code"
            @click="getEmailCode"
            :disabled="disabled4"
          >{{emailCodeText}}</el-button>
        </div>
        <el-input
          type="text"
          placeholder="请输入邮箱"
          v-model="inputEmail"
          clearable
          class="modify1_content getPass"
          style="margin-top: 10px;"
        ></el-input>
        <div class="modify_foot">
          <el-button type="primary" class="demo2_btn" @click="setEmail">确认</el-button>
        </div>
      </div>
    </div>
    <el-dialog id="firstTimeRechargePopup" :visible.sync="isFirstTimeRecharge">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px; display:none">首充礼品清单</p>
          <div v-html="before_recharge" style="cursor:pointer" @click="goToRechargeContent()">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="cancelRecharge()">取消</el-button>
        <el-button type="primary" @click="goToRecharge()">立即充值</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
import utils from "../assets/js/utils";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Information",
  data() {
    return {
      real: "未认证", //真实姓名
      realStatus: "认证", //实名认证状态
      inputReal: "", //输入框 真实姓名
      inputIdcard: "", //身份证号
      bank: "未绑定",
      bankStatus: "绑定", //银行状态
      bankName: "", //银行名称
      bankValue: "", //银行卡号
      backAccess: "", //开户行地址
      inputBankCode: "", //银行卡号
      inputBankName: "", //开户人姓名
      inputBankAccess: "", //银行地址
      bankId: "", //银行id
      bankList: [], //银行列表
      nickName: "未设置", //昵称
      nickStatus: "设置", //昵称状态
      inputNickName: "", //昵称
      phone: "未绑定", //手机号码
      phoneStatus: "绑定", //手机号码状态
      inputPhone: "", //手机号码
      inputPhoneCode: "", //验证码
      getCodeText: "获取验证码",
      disabled: false, //获取验证码按钮
      inputLoginPhone: "", //获取手机号
      inputLoginPass: "", //新密码
      inputLoginConf: "", //确认密码
      inputLoginCode: "", //登录验证码
      getLoginCodeText: "获取验证码",
      disabled2: false, //获取验证码按钮
      pay: "未设置", //支付密码文字
      payPassStatus: "设置", //支付密码状态
      inputPayPass: "", //支付密码
      inputPayConf: "", //确认密码
      inputPayCode: "", //验证码
      getPayCodeText: "获取验证码", //
      disabled3: false, //获取验证码按钮
      email: "未设置", //..
      emailStatus: "设置",
      emailCodeText: "获取验证码",
      disabled4: false,
      inputEmailCode: "",
      isFirstTimeRecharge: false,
      inputEmail: "",
      before_recharge: "",
      loginRePicCode:"",
      payRePicCode:"",
      captcha:'',
      verify_token:''
    };
  },
  mounted: function() {
    this.getCaptcha();
    this.getConfig();
    this.rechargeConfig();
    // this.isRealNamePopShowM();
    this.isRechargePopShowM();
  },
  methods: {
    getCaptcha(){
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "getSmsPic",
        },
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$message.error(res.data.msg);
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    goToRechargeContent() {
      // this.$router.push({path:'/popcontent?activityid=recharge_popup_image'})
       this.$router.push({
            path:"/popcontent1?activityid=recharge_popup_image_pc"
          })
          //  this.$router.push({
          //   path:"/stockdetailed?symbol=sh000001"
          // })
    },
     realNameConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"sys_give_voucher_amount"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.sys_give_voucher_amount = res.data.data;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
        isRealNamePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_real_name_popup"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRealNamePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },

        isRechargePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRechargePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },

         isFirstRecharge() {
          //  if(res.data.data.cash == "0.00") {
          //         that.rechargeConfig();
          //         that.isFirstTimeRecharge = true;
          //     } else {
          //         that.isFirstTimeRecharge = false;
          //         that.isFirstTrade();
          //     }
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "isfirst_recharge",
                  token: sessionStorage.getItem("token"),
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                  that.isFirstTimeRecharge = true;
                  that.isFirstTrade();
                  // localStorage.setItem("isFirstTimeRecharge", false);
                } else {
                  if(that.isRechargePopShow) {
                    that.rechargeConfig();
                    that.isFirstTimeRecharge = true;
                  }
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
     rechargeConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.before_recharge = res.data.data;
                } else {

                }
              });
        },


    getConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.inputLoginPhone = res.data.data.phone1;
            //实名认证
            if (res.data.data.real != null) {
              //已认证
              that.real = res.data.data.real;
              that.realStatus = "";
            } else {
              //未认证
              that.real = "未认证";
              that.realStatus = "认证";
            }
            //绑定银行卡
            if (res.data.data.bank != 0) {
              //已绑定
              that.bank = "";
              that.bankStatus = "修改";
              that
                .$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "bank_info",
                    token: sessionStorage.getItem("token")
                  }
                })
                .then(function(res) {
                  if (res.data.code == 1) {
                    that.bankName = res.data.data.name;
                    that.bankValue = res.data.data.card;
                    that.backAccess = res.data.data.address;
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$message.error(res.data.msg);
                  }
                });
            } else {
              //未绑定
              that.bank = "未认证";
              that.bankStatus = "绑定";
              that.bankName = ""; //银行名称
              that.bankValue = ""; //银行卡号
              that.backAccess = ""; //开户行地址
            }
            //修改昵称
            if (res.data.data.name == "") {
              //未设置
              that.nickName = "未设置"; //昵称
              that.nickStatus = "设置"; //昵称状态
            } else {
              //已设置
              that.nickName = res.data.data.name; //昵称
              that.nickStatus = "修改"; //昵称状态
            }
            //修改手机号码
            if (res.data.data.phone == "") {
              //未设置
              that.phone = "未设置"; //手机号
              that.phoneStatus = "设置"; //手机号状态
            } else {
              //已设置
              that.phone = res.data.data.phone; //手机号
              that.phoneStatus = "修改"; //手机号状态
            }
            //提款密码
            if (res.data.data.withdrawal == 0) {
              //未设置
              that.pay = "未设置"; //
              that.payPassStatus = "设置"; //
            } else {
              //已设置
              //已设置
              that.pay = "已设置"; //
              that.payPassStatus = "修改"; //
            }
            //邮箱
            if (res.data.data.email == "") {
              //未设置
              that.email = "未绑定"; //
              that.emailStatus = "绑定"; //
            } else {
              //已设置
              that.email = res.data.data.email; //
              that.emailStatus = "修改"; //
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //实名认证弹窗出现
    realFadeIn() {
      $(".modify-real").fadeIn(100);
    },
    realFadeOut() {
      $(".modify-real").fadeOut(100);
    },
    //实名认证
    setReal() {
      let that = this;
      localStorage.setItem("isFirstTimeRecharge", true);
      if (that.inputReal == "") {
        that.$message.error("请输入真实姓名");
      } else if (that.inputIdcard == "") {
        that.$message.error("请输入身份证号");
      } else {
        $(".modify-real").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "certification",
              token: sessionStorage.getItem("token"),
              name: that.inputReal,
              card: that.inputIdcard
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.isFirstTimeRecharge = true;
              localStorage.setItem("isFirstTimeRecharge", true);
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.real = that.inputReal;
              that.realStatus = "";
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //银行卡绑定窗出现
    bankFadeIn() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bank_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.bankList = res.data.data.bank;
            that.bankId = that.bankList[0].id;
            $(".modify-bank").fadeIn(100);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    bankFadeOut() {
      $(".modify-bank").fadeOut(100);
    },
    //银行卡绑定 修改
    setBank() {
      let that = this;
      if (that.inputBankCode == "") {
        that.$message.error("请输入银行卡号");
      } else if (that.inputBankName == "") {
        that.$message.error("请输入开户人姓名");
      } else if (that.inputBankAccess == "") {
        that.$message.error("请输入开户行地址");
      } else {
        $(".modify-bank").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "bind_bank",
              token: sessionStorage.getItem("token"),
              name: that.inputBankName,
              bank_id: that.bankId,
              address: that.inputBankAccess,
              card: that.inputBankCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.bank = "";
              that.bankStatus = "修改";
              that
                .$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "bank_info",
                    token: sessionStorage.getItem("token")
                  }
                })
                .then(function(res) {
                  if (res.data.code == 1) {
                    that.bankName = res.data.data.name;
                    that.bankValue = res.data.data.card;
                    that.backAccess = res.data.data.address;
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$message.error(res.data.msg);
                  }
                });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //修改昵称弹窗出现
    nickFadeIn() {
      $(".modify-nick").fadeIn(100);
    },
    nickFadeOut() {
      $(".modify-nick").fadeOut(100);
    },
    //修改昵称操作
    setNick() {
      let that = this;
      if (that.inputNickName == "") {
        that.$message.error("请输入昵称");
      } else {
        $(".modify-nick").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_name",
              token: sessionStorage.getItem("token"),
              name: that.inputNickName
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.nickName = that.inputNickName;
              that.nickStatus = "修改";
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //修改手机号码 弹窗出现
    phoneFadeIn() {
      let that = this;
      $(".modify-phone").fadeIn(100);
    },
    phoneFadeOut() {
      $(".modify-phone").fadeOut(100);
    },
    //修改手机号码
    setPhone() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.inputPhone)) {
        that.$message.error("手机号码格式不正确");
      } else if (that.inputPhoneCode == "") {
        that.$message.error("请输入验证码");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.inputPhone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);

        $(".modify-phone").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_phone_e",
              token: sessionStorage.getItem("token"),
              phone: phoneNumber,
              code: that.inputPhoneCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.inputLoginPhone = that.inputPhone;
              var str1 = that.inputPhone.slice(0, 3);
              var str2 = that.inputPhone.slice(7, 11);
              that.phone = str1 + "****" + str2;
              that.phoneStatus = "修改";
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //获取验证码
    getCode() {
      let that = this;
      clearInterval(window.timer1);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.inputPhone)) {
        that.$message.error("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.inputPhone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modifyInfo_code_e",
              info: phoneNumber,
              type: 2
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 2000
              });
              var time = 60;
              that.disabled = true;
              that.getCodeText = time + "s";
              window.timer1 = setInterval(function() {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  clearInterval(window.timer1);
                  that.disabled = false;
                  that.getCodeText = "获取验证码";
                }
              }, 1000);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //登录密码 弹窗出现
    loginFadeIn() {
      $(".modify-login").fadeIn(100);
    },
    loginFadeOut() {
      this.loginRePicCode="";
      $(".modify-login").fadeOut(100);
    },
    //获取验证码
    getLoginCode() {
      let that = this;
      clearInterval(window.timer2);
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.inputLoginPhone.toString();
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modifyInfo_code_e",
            info: phoneNumber,
            type: 0,
            rePicCode: that.loginRePicCode,
            verify_token:that.verify_token,
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000
            });
            var time = 60;
            that.disabled2 = true;
            that.getLoginCodeText = time + "s";
            window.timer2 = setInterval(function() {
              time--;
              that.getLoginCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled2 = false;
                that.getLoginCodeText = "获取验证码";
              }
            }, 1000);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //修改登录密码 操作
    setLoginPass() {
      let that = this;
      if (that.inputLoginCode == "") {
        that.$message.error("请输入验证码");
      } else if (that.inputLoginPass == "") {
        that.$message.error("请输入新密码");
      } else if (that.inputLoginConf == "") {
        that.$message.error("请输入确认密码");
      } else if (that.inputLoginConf != that.inputLoginPass) {
        that.$message.error("两次密码输入不一致");
      } else {
        $(".modify-login").fadeOut(100);

        let publicKey = localStorage.getItem("encript_public_key");
        let inputPassWord = that.encryptMessage(that.inputLoginPass, publicKey);
        let inputPassWordCon = that.encryptMessage(that.inputLoginConf, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_login_e",
              token: sessionStorage.getItem("token"),
              password: inputPassWord,
              confirm: inputPassWordCon,
              code: that.inputLoginCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              
              that.$store.state.loginType = false;
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("loginType");
              that.$router.push({
                path: "/login"
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //支付密码 弹窗出现
    payFadeIn() {
      $(".modify-pay").fadeIn(100);
    },
    payFadeOut() {
      this.payRePicCode="";
      $(".modify-pay").fadeOut(100);
    },
    //获取验证码
    getPayCode() {
      let that = this;
      that.disabled3 = true;
      clearInterval(window.timer2);
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.inputLoginPhone.toString();
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modifyInfo_code_e",
            info: phoneNumber,
            type: 1,
            rePicCode: that.payRePicCode,
            verify_token:that.verify_token
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000
            });
            var time = 60;
            that.getPayCodeText = time + "s";
            window.timer2 = setInterval(function() {
              time--;
              that.getPayCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled3 = false;
                that.getPayCodeText = "获取验证码";
              }
            }, 1000);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //修改登录密码 操作
    setPayPass() {
      let that = this;
      if (that.inputPayCode == "") {
        that.$message.error("请输入验证码");
      } else if (that.inputPayPass == "") {
        that.$message.error("请输入密码");
      } else if (that.inputPayConf == "") {
        that.$message.error("请输入确认密码");
      } else if (that.inputPayConf != that.inputPayPass) {
        that.$message.error("两次密码输入不一致");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let inputPassWord = that.encryptMessage(that.inputPayPass, publicKey);
        let inputPassWordCon = that.encryptMessage(that.inputPayConf, publicKey);
        $(".modify-pay").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_pay_e",
              token: sessionStorage.getItem("token"),
              password: inputPassWord,
              confirm: inputPassWordCon,
              code: that.inputPayCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {

              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.payRePicCode='';
              that.inputPayCode='';
              that.inputPayPass='';
              that.inputPayConf='';
              that.pay = "已设置"; //支付密码文字
              that.payPassStatus = "修改"; //支付密码状态
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //支付密码 弹窗出现
    emailFadeIn() {
      $(".modify-email").fadeIn(100);
    },
    emailFadeOut() {
      $(".modify-email").fadeOut(100);
    },
    //获取验证码
    getEmailCode() {
      let that = this;
      clearInterval(window.timer2);
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.inputLoginPhone.toString();
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modifyInfo_code_e",
            info: phoneNumber,
            type: 3
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000
            });
            var time = 60;
            that.disabled4 = true;
            that.emailCodeText = time + "s";
            window.timer2 = setInterval(function() {
              time--;
              that.emailCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled4 = false;
                that.emailCodeText = "获取验证码";
              }
            }, 1000);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
     cancel() {
      this.isRealNameVerified = false;
    },
    cancelRecharge() {
      this.isFirstTimeRecharge = false;
    },
    cancelTrade() {
      this.isFirstTimeTrading = false;
    },
    goToRealName() {
      this.$router.push({path:'/myaccount/information'})
    },
    goToRecharge() {
      this.$router.push({path:'/myaccount/capital'})
    },
    goToTrade() {
      this.$router.push({
            path:"/operate/operateday"
          })
    },
    //修改登录密码 操作
    setEmail() {
      let that = this;
      if (that.inputEmailCode == "") {
        that.$message.error("请输入验证码");
      } else if (that.inputEmail == "") {
        that.$message.error("请输入邮箱");
      } else {
        $(".modify-email").fadeOut(100);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_email",
              token: sessionStorage.getItem("token"),
              email: that.inputEmail,
              code: that.inputEmailCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.email = that.inputEmail;
              that.emailStatus = "修改";
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.perfect_left {
  width: 1000px;
  float: right;
  text-align: center;
}
.perfect_title {
  width: 100%;
  height: 30px;
  text-align: left;
  margin: 56px 0 30px 0;
  border-bottom: 1px solid #2b7ea8;
}
.perfect_title div {
  width: 100px;
  font-size: 14px;
  line-height: 14px;
  color: #2f7ca8;
  padding-bottom: 15px;
  border-bottom: 3px solid #2f7ca8;
  margin-left: 10px;
  text-align: center;
}
.perfect_content {
  width: 1000px;
  margin: 20px auto 0;
  border: 1px solid #eee;
}
.content_title {
  height: 80px;
  line-height: 100px;
  font-size: 20px;
  text-align: left;
  margin-left: 20px;
}
.content_table {
  margin-bottom: 40px;
}
.content_table table {
  width: 924px;
  margin: 0 auto;
  height: 310px;
  margin-bottom: 40px;
  border: 1px solid #ccc;
}
.content_table table tr td:nth-child(1) {
  width: 240px;
  height: 55px;
  text-align: left;
  color: #666;
  background-color: #f3f3f3;
  border-bottom: 1px solid white;
}
.content_table table tr td:nth-child(1) img {
  vertical-align: bottom;
  margin-left: 50px;
}
.content_table table tr td:nth-child(2) {
  width: 648px;
  height: 55px;
  overflow: hidden;
  background-color: white;
  border-bottom: 1px solid #ccc;
}
.content_table table tr td:nth-child(2) div:nth-child(1) select {
  height: 30px;
}
.content_table table tr td:nth-child(2) div:nth-child(1) {
  float: left;
  color: #101010;
  /* font-weight: 600; */
  margin-left: 40px;
  font-size: 14px;
}
.content_table
  table
  tr
  td:nth-child(2)
  div[data-v-7b54854c]:nth-child(1)
  > span {
  display: inline-block;
  margin-right: 5px;
}
.content_table table tr td:nth-child(2) div:nth-child(2) {
  float: right;
  color: #62a1d6;
  border-bottom: 1px solid #62a1d6;
  margin-right: 60px;
  cursor: pointer;
  font-size: 14px;
}
.content_table table tr #change {
  border-bottom: 0;
}
/*弹窗1*/
.modify1,
.modify2,
.modify3,
.modify4,
.modify5 {
  width: 480px;
  height: 245px;
  border-radius: 10px;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  border: 1px solid #000;
}
.modify11 {
  height: 3q10px;
}
.modify2 {
  height: 285px;
}
.modify3 {
  height: 285px;
}
.modify4 {
  height: 400px;
}
.modify5 {
  height: 415px;
}
.modify_title {
  width: 400px;
  margin: 0 auto;
  overflow: hidden;
  height: 80px;
  line-height: 100px;
  font-size: 20px;
}
.modify_title div:nth-child(1) {
  float: left;
  color: #5c5992;
  font-weight: 600;
}
.modify_title div:nth-child(2) {
  float: right;
  font-size: 30px;
  cursor: pointer;
}
.modify1_content {
  width: 400px;
  margin: 0 auto;
}
.modify1_content input {
  width: 85%;
  height: 40px;
}
.choice_bank {
  outline: none;
  border: none;
  font-size: 14px;
  line-height: 40px;
  width: 356px;
  display: inline-block;
  height: 40px;
  background: transparent;
}
.choice_bank > option {
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
}
.modify_foot button {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: inline-block;
  width: 200px;
  margin: 0 auto;
  height: 45px;
  font-size: 16px;
}
.instead {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.6);
}
/*弹窗2*/

.modify2_content {
  width: 400px;
  margin: 0 auto;
}
.modify2_content div:nth-child(1) {
  margin-bottom: 40px;
}
.modify3_content div:nth-child(1),
.modify3_content div:nth-child(4) {
  width: 400px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto 20px;
  border: 1px solid #ddd;
}
.modify3_content div:nth-child(1) span,
.modify3_content div:nth-child(4) span {
  font-size: 20px;
  margin-left: 15px;
}
.modify3_content div:nth-child(1) input,
.modify3_content div:nth-child(4) input {
  width: 80%;
  height: 30px;
  line-height: 45px;
  /*border: 1px solid #000;*/
}
.code1,
.code2 {
  width: 400px;
  position: relative;
  overflow: hidden;
  margin: 20px auto;
}
.code1 span,
.code2 span {
  width: 10%;
  font-size: 20px;
  position: absolute;
  left: 15px;
  top: 10px;
  vertical-align: middle;
}
.code1 input,
.code2 input {
  height: 40px;
  line-height: 40px;
  width: 58%;
  border: 1px solid #ddd;
  padding-left: 40px;
  float: left;
  /*margin-left: 8px;*/
}
.code1 img,
.code2 button {
  float: left;
  margin-left: 10px;
}
.code2 button {
  width: 28%;
  height: 40px;
  color: white;
  background-color: #566b96;
}
.getPass {
  margin: 20px auto;
  display: block;
}
.select-class {
  margin: 20px auto;
  display: block;
  width: 400px;
  font-size: 14px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.modifybox {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 9;
}
/* 绑定手机号 */
.modify-codebox {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: 20px auto;
}
.modify-code {
  width: 283px;
}
</style>

<style>
#firstTimeRechargePopup .el-form-item{
  margin-bottom: 11px;
}
#firstTimeRechargePopup .el-dialog__body {
  padding: 0px;
}
#firstTimeRechargePopup .el-form-item__content {
  margin-left: 0px !important;
}
#firstTimeRechargePopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
.repic-code {
   width: 240px;
 }
</style>



// WEBPACK FOOTER //
// src/components/information.vue